import React from 'react';
import HomeScreen from "../../homescreen/homescreen";
import LoadingComponent from "../../../components/Loading";
import Service from "../../../service/service";
import ErrorMessage from "../../../components/ErrorMessage";
import SuccessMessage from "../../../components/SuccessMessage";

class UserInfo extends HomeScreen {

    state = {
        userInfo: null,
        loading: true,
        errorMessage: null,
        success: false
    };

    service = new Service();

    changePassword = {
        password: null,
        secondPassword: null
    };

    componentDidMount() {
        //const str = "{\"id\":1,\"username\":\"testusername@email.com\",\"email\":\"testusername@email.com\",\"firstName\":\"firstName\",\"lastName\":\"lastName\",\"profileUrl\":\"www.google.com.ar\",\"registerTimestamp\":\"2022-05-13T23:00:37.000+00:00\",\"modifiedTimestamp\":\"2022-05-29T20:49:52.000+00:00\",\"enabled\":true,\"validated\":true,\"metadata\":\"{}\"}";
        //this.state.userInfo = JSON.parse(str);
        this.state.userInfo = this.service.getUserInfo();
        this.state.loading = false;
        this.setState(this.state);
    }

    getScreenName() {
        return 'User Info';
    }

    handleChange = (event) => {
        this.changePassword[event.target.name] = event.target.value;
        this.setState(this.changePassword);
    };

    updatePassword = () => {
        const {password, secondPassword} = this.changePassword;
        if (password == null || password.length < 4 || password !== secondPassword) {
            this.state.errorMessage = 'Insert a password longer than 4 characters, and make sure both password match.';
            this.setState(this.state);
        } else {
            this.state.loading = true;
            this.state.errorMessage = null;
            this.setState(this.state);
            this.service.updatePassword(password)
                .then(response => {
                    console.debug(response);
                    this.state.loading = false;
                    this.state.success = true;
                    this.setState(this.state);
                })
                .catch(error => {
                    console.debug(error);
                    this.state.loading = false;
                    this.state.errorMessage = 'There was an error updating the password.';
                    this.setState(this.state);
                });
        }
        //this.service.logout();
    };

    renderHomeContent() {

        const {userInfo, success} = this.state;

        return (
            <div>
                { userInfo &&
                    <div>
                        <p className='sectionDescription'><b className='highlight'>Username: </b>{userInfo.username}</p>
                        <p className='sectionDescription'><b className='highlight'>Email: </b>{userInfo.email}</p>
                        <p className='sectionDescription'><b className='highlight'>First Name: </b>{userInfo.firstName}</p>
                        <p className='sectionDescription'><b className='highlight'>Last Name: </b>{userInfo.lastName}</p>
                        <p className='sectionDescription'><b className='highlight'>Registered Time: </b>{userInfo.registerTimestamp}</p>
                        <p className='sectionDescription'><b className='highlight'>Last Updated Time: </b>{userInfo.modifiedTimestamp}</p>

                        { success && <SuccessMessage message='The password has been updated successfully.'/> }
                        { !success && this.renderUpdatePassword() }

                    </div>
                }
            </div>
        );
    }

    renderUpdatePassword = () => {
        const {loading, errorMessage} = this.state;
        const buttonClass = loading ? 'myButton myButtonDisabled' : 'myButton myButtonActive';
        return (
            <div className='innerFormContainer'>
                <p className='sectionDescription'><b className='highlight'>Change your password:</b></p>
                <div className='formContainer'>
                    <div>
                        <label>Password:</label>
                        <input type='password'
                               name='password'
                               placeholder='Password'
                               value={this.changePassword.password}
                               onChange={this.handleChange} disabled={loading} />
                    </div>
                    <div>
                        <label>Repeat your Password:</label>
                        <input type='password'
                               name='secondPassword'
                               placeholder='Password'
                               value={this.changePassword.secondPassword}
                               onChange={this.handleChange} disabled={loading} />
                    </div>
                </div>

                <LoadingComponent isLoading={loading} />

                <ErrorMessage errorMessage={errorMessage} type='warning'/>

                <div className='buttonContainer'>
                    <div className={buttonClass} onClick={this.updatePassword}>Update</div>
                </div>
            </div>
        );
    };

}

export default UserInfo;


// WEBPACK FOOTER //
// ./src/screens/access/userinfo/index.js